import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {CdkDrag} from '@angular/cdk/drag-drop';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HeaderComponent } from './components/shared/header/header.component';
import { FooterComponent } from './components/shared/footer/footer.component';
import { EstadisticasInicialComponent } from './components/home/estadisticas-inicial/estadisticas-inicial.component';
import { InformacionSerieComponent } from './components/home/informacion-serie/informacion-serie.component';
import { CatalogoDatosComponent } from './components/home/catalogo-datos/catalogo-datos.component';
import { EstadisticaEncuestasComponent } from './components/home/estadistica-encuestas/estadistica-encuestas.component';
import { EncuestasBoletinesComponent } from './components/home/encuestas-boletines/encuestas-boletines.component';
import { WebServiceComponent } from './components/home/web-service/web-service.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';
import { MatListModule } from '@angular/material/list';
import { MatTreeModule } from '@angular/material/tree';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';

import {CdkAccordionModule} from '@angular/cdk/accordion';

// Import highcharts modules
import { HighchartsChartModule } from 'highcharts-angular';
import * as more from 'highcharts/highcharts-more.src';

import { NumberFormatCustom } from './components/shared/formatter/NumberFormatCustom';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { DetalleSerieDialogComponent } from './components/home/dialog/detalle-serie-dialog/detalle-serie-dialog.component';
import { EncuestaComponent } from './components/home/informacion-serie/encuesta/encuesta.component';
import { NotaFeErrataComponent } from './components/home/dialog/nota-fe-errata/nota-fe-errata.component';
import { CalendarioBanrepComponent } from './components/home/calendario/calendario-banrep.component';
import { MercadoCambiarioComponent } from './components/home/mercado-cambiario/mercado-cambiario.component';
import { DashboardComponent } from './components/home/dashboard/dashboard.component';
import { HeaderCatalogoComponent } from './components/shared/header-catalogo/header-catalogo.component';
import { MetadataSerieComponent } from './components/home/metadata-serie/metadata-serie.component';
import { GraficaAnaliticaComponent } from './components/home/grafica-analitica/grafica-analitica.component';
import { MenuAlternoComponent } from './components/home/public/menu-alterno/menu-alterno.component';
import { DetalleBoletinComponent } from './components/home/encuestas-boletines/detalle-boletin/detalle-boletin.component';
import { EncuestaSatisfaccionComponent } from './components/home/public/encuesta-satisfaccion/encuesta-satisfaccion.component';
import { SuperMenuComponent } from './components/home/public/super-menu/super-menu.component';
import { DetalleCatalogoComponent } from './components/home/catalogo-datos/detalle-catalogo/detalle-catalogo.component';
import { MegaMenuComponent } from './components/home/public/mega-menu/mega-menu.component';
import { RetornoEstadisticasComponent } from './components/home/public/retorno-estadisticas/retorno-estadisticas.component';
import { OpinionComponent } from './components/home/estadisticas-inicial/opinion/opinion.component';
import { MenuMasConsultadosComponent } from './components/home/public/menu-mas-consultados/menu-mas-consultados.component';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    EstadisticasInicialComponent,
    InformacionSerieComponent,
    CatalogoDatosComponent,
    EstadisticaEncuestasComponent,
    EncuestasBoletinesComponent,
    WebServiceComponent,
    DetalleSerieDialogComponent,
    EncuestaComponent,
    NotaFeErrataComponent,
    CalendarioBanrepComponent,
    NumberFormatCustom,
    MercadoCambiarioComponent,
    DashboardComponent,
    HeaderCatalogoComponent,
    MetadataSerieComponent,
    GraficaAnaliticaComponent,
    MenuAlternoComponent,
    DetalleBoletinComponent,
    EncuestaSatisfaccionComponent,
    SuperMenuComponent,
    DetalleCatalogoComponent,
    MegaMenuComponent,
    RetornoEstadisticasComponent,
    OpinionComponent,
    MenuMasConsultadosComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    NoopAnimationsModule,
    MatDialogModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatTabsModule,
    MatListModule,
    MatTreeModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatIconModule,
    CdkAccordionModule,
    HighchartsChartModule,
    MatSidenavModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatTableModule,
    CdkDrag,
    MatPaginatorModule
  ],
  providers: [NumberFormatCustom,
    //{provide:LocationStrategy, useClass: HashLocationStrategy}
    {provide: HashLocationStrategy, useFactory: () => [more]}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
